import Vue from 'vue'

Vue.filter('getGender', val => {
    switch (val) {
        case 'M' :
            return 'ชาย';
        case 'F' :
            return 'หญิง';
        case 'NS' :
            return 'ไม่ระบุ';
        default :
            return 'Unknown';
    }
});


Vue.filter('getAgeRange', val => {
    switch (val) {
        case '1' :
            return 'ต่ำกว่า 20 ปี';
        case '2' :
            return '20 - 40 ปี';
        case '3' :
            return '41 - 60 ปี';
        case '4' :
            return '61 - 80 ปี';
        case '5' :
            return 'มากกว่า 80 ปี';
        case '6' :
            return 'ไม่ระบุ';
        default :
            return 'Unknown';
    }
});


Vue.filter('getSatisfaction', val => {
    switch (val) {
        case '1' :
            return 'พอใจน้อยที่สุด';
        case '2' :
            return 'พอใจน้อย';
        case '3' :
            return 'พอใจปานกลาง';
        case '4' :
            return 'พอใจมาก';
        case '5' :
            return 'พอใจมากที่สุด';
        default :
            return 'Unknown';
    }
});

